var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as PropTypes from 'prop-types';
import * as _ from 'lodash';
import { customPropTypes, AutoControlledComponent, createShorthandFactory, isFromKeyboard, commonPropTypes, } from '../../lib';
import Label from '../Label/Label';
import Icon from '../Icon/Icon';
import { radioGroupItemBehavior } from '../../lib/accessibility';
/**
 * A single radio within a radio group.
 * @accessibility
 * Radio items need to be grouped in RadioGroup component to correctly handle accessibility.
 */
var RadioGroupItem = /** @class */ (function (_super) {
    __extends(RadioGroupItem, _super);
    function RadioGroupItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleFocus = function (e) {
            _this.setState({ isFromKeyboard: isFromKeyboard() });
            _.invoke(_this.props, 'onFocus', e, _this.props);
        };
        _this.handleBlur = function (e) {
            _this.setState({ isFromKeyboard: false });
            _.invoke(_this.props, 'onBlur', e, _this.props);
        };
        _this.handleClick = function (e) {
            _.invoke(_this.props, 'onClick', e, _this.props);
        };
        return _this;
    }
    RadioGroupItem.prototype.componentDidUpdate = function (prevProps, prevState) {
        var checked = this.state.checked;
        if (checked !== prevState.checked) {
            checked && this.props.shouldFocus && this.elementRef.focus();
            _.invoke(this.props, 'checkedChanged', undefined, __assign({}, this.props, { checked: checked }));
        }
    };
    RadioGroupItem.prototype.componentDidMount = function () {
        this.elementRef = ReactDOM.findDOMNode(this);
    };
    RadioGroupItem.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, rest = _a.rest, styles = _a.styles, variables = _a.variables, accessibility = _a.accessibility;
        var _b = this.props, label = _b.label, icon = _b.icon;
        return (React.createElement(ElementType, __assign({}, accessibility.attributes.root, accessibility.keyHandlers.root, rest, { onFocus: this.handleFocus, onBlur: this.handleBlur, onClick: this.handleClick, className: classes.root }),
            React.createElement(Label, { styles: styles.label },
                Icon.create(icon || '', {
                    defaultProps: {
                        circular: true,
                        size: 'smaller',
                        variables: variables.icon,
                        styles: styles.icon,
                    },
                }),
                label)));
    };
    RadioGroupItem.displayName = 'RadioGroupItem';
    RadioGroupItem.className = 'ui-radiogroup__item';
    RadioGroupItem.propTypes = __assign({}, commonPropTypes.createCommon({
        content: false,
    }), { accessibility: PropTypes.oneOfType([PropTypes.object, PropTypes.func]), checked: PropTypes.bool, defaultChecked: PropTypes.bool, disabled: PropTypes.bool, icon: customPropTypes.itemShorthand, label: customPropTypes.nodeContent, name: PropTypes.string, onBlur: PropTypes.func, onClick: PropTypes.func, onFocus: PropTypes.func, checkedChanged: PropTypes.func, shouldFocus: PropTypes.bool, value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), vertical: PropTypes.bool });
    RadioGroupItem.defaultProps = {
        as: 'div',
        accessibility: radioGroupItemBehavior,
    };
    RadioGroupItem.autoControlledProps = ['checked'];
    return RadioGroupItem;
}(AutoControlledComponent));
RadioGroupItem.create = createShorthandFactory(RadioGroupItem);
export default RadioGroupItem;
